import React from 'react';

export const useStyleAndClass = ({parameter, lfo, envelope, sequencerEngine, keyScaling, zoomMin, zoomMax}) => {
    let mod = keyScaling || parameter.getParameterMod(envelope || lfo);
    if (!mod.scale && !keyScaling) {
        return undefined;
    }

    let min = Math.min(mod.min, mod.max);
    let max = Math.max(mod.min, mod.max);

    let range = zoomMax - zoomMin;
    let start = (min - zoomMin) / range;
    let end = (max - zoomMin) / range;
    let width = end - start;
    if (start < 0) {
        start = 0;
    }else if (start > 1) {
        start = 1;
    }
    let style = {
        marginLeft: (start * 100) + '%',
        width: (width * 100) + '%',
    };
    let className = "modulator-indicator";
    let num = 0;
    let thumbClass = "modulator-thumb ";
    if (lfo) {
        num = parameter.availableLFOs.indexOf(lfo); 
        thumbClass += " lfo-" + num + " toggled";
        className += " lfo-" + num + " toggled" 
    } else if (envelope) {
        num = parameter.availableEnvelopes.indexOf(envelope); 
        className += " lfo-" + num + " toggled" 
        thumbClass += " lfo-" + num + " toggled" + " env";
    } else if (keyScaling) {
        thumbClass += " key-scaling";
        className += " key-scaling";
    }

    return {style, className, mod, num, thumbClass};
}
